import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "mt-2 text-right" }
const _hoisted_3 = { class: "w-full flex justify-center" }
const _hoisted_4 = ["viewBox"]
const _hoisted_5 = ["cx", "cy", "r"]
const _hoisted_6 = ["cx", "cy", "r", "stroke-width"]
const _hoisted_7 = ["cx", "cy", "r", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_8 = ["font-size"]
const _hoisted_9 = {
  x: "50%",
  y: "50%",
  "font-weight": "bold",
  "text-anchor": "middle",
  class: "text-primary-main fill-current",
  "dominant-baseline": "middle"
}
const _hoisted_10 = ["font-size"]
const _hoisted_11 = ["font-size"]
const _hoisted_12 = {
  x: "50%",
  y: "65%"
}
const _hoisted_13 = {
  x: "50%",
  y: "75%"
}
const _hoisted_14 = ["font-size"]
const _hoisted_15 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExchangeCards = _resolveComponent("ExchangeCards")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseCard, { class: "sm:w-6/12 text-center m-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: _ctx.entryLinkTo,
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                class: "text-xs",
                buttonClass: "outlined"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pointChargeButtonLabel), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", {
            class: "w-5/6 h-5/6",
            viewBox: `0 0 ${_ctx.VIEW_LENGTH} ${_ctx.VIEW_LENGTH}`
          }, [
            _createElementVNode("circle", {
              class: "text-white fill-current",
              cx: _ctx.CX,
              cy: _ctx.CY,
              r: _ctx.RADIUS
            }, null, 8, _hoisted_5),
            _createElementVNode("circle", {
              class: "text-gray-400 stroke-current",
              cx: _ctx.CX,
              cy: _ctx.CY,
              r: _ctx.RADIUS,
              fill: "transparent",
              "stroke-width": _ctx.strokeWidth
            }, null, 8, _hoisted_6),
            _createElementVNode("circle", {
              class: "text-primary-light stroke-current",
              cx: _ctx.CX,
              cy: _ctx.CY,
              r: _ctx.RADIUS,
              fill: "transparent",
              "stroke-width": _ctx.strokeWidth,
              "stroke-dasharray": _ctx.strokeDasharray,
              "stroke-dashoffset": _ctx.CIRCUMFERENCE / 4
            }, null, 8, _hoisted_7),
            _createElementVNode("g", null, [
              _createElementVNode("text", {
                x: "50%",
                y: "35%",
                "text-anchor": "middle",
                "font-size": _ctx.RADIUS / 8,
                class: "text-gray-500 fill-current"
              }, _toDisplayString(_ctx.pointLabelTitle), 9, _hoisted_8),
              _createElementVNode("text", _hoisted_9, [
                _createElementVNode("tspan", {
                  "font-size": _ctx.RADIUS / 4
                }, _toDisplayString(_ctx.walletPoint), 9, _hoisted_10)
              ]),
              (_ctx.nextExchangePoint)
                ? (_openBlock(), _createElementBlock("text", {
                    key: 0,
                    x: "50%",
                    y: "65%",
                    "text-anchor": "middle",
                    "font-size": _ctx.RADIUS / 8,
                    class: "text-gray-500 fill-current"
                  }, [
                    _createElementVNode("tspan", _hoisted_12, _toDisplayString(_ctx.nextExchangeNeedPointPrefix), 1),
                    _createElementVNode("tspan", _hoisted_13, _toDisplayString(_ctx.nextExchangePoint) + _toDisplayString(_ctx.nextExchangeNeedPointSuffix), 1)
                  ], 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("text", {
                    key: 1,
                    x: "50%",
                    y: "65%",
                    "text-anchor": "middle",
                    "font-size": _ctx.RADIUS / 8,
                    class: "text-gray-500 fill-current"
                  }, _toDisplayString(_ctx.allExchangeEnalbe), 9, _hoisted_14))
            ])
          ], 8, _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_ExchangeCards)
        ])
      ]),
      _: 1
    })
  ]))
}